import { useTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "@progress/kendo-react-layout";
import { Button, Col, List, Row } from "reactstrap";
import EventService from "../../../services/srv-event/EventService";
import { confirmAlert } from "react-confirm-alert";
import { getConfirmWarningMessage } from "../../../helpers/utils";
import { formatDate } from "@progress/kendo-intl";

function EventInfoCard(props) {
  const { t } = useTranslation();

  const additionalInfo = props.event.eK_ALANLAR
    ? JSON.parse(props.event.eK_ALANLAR)
    : [];

  const renderListItem = (icon, label, value) => {
    if (!value) return null;
    return (
      <>
        <li>
          <i className={`fa ${icon}`}></i> {t(label)} :{" "}
          <b>
            {/* Tarih gelirse formatlamak için */}
            {typeof value === "string" &&
            /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2})?/.test(value)
              ? formatDate(
                  new Date(value),
                  value.includes("T")
                    ? t("date_formats.longDateTime")
                    : t("date_formats.shortDate")
                )
              : t(value)}
          </b>
        </li>
        <hr />
      </>
    );
  };

  function addToCalendar() {
    const defaultAlertMessages = {
      TittleWarning: t("warning"),
      MessageDetailWarning: t("are_you_sure_for_company_calendar_add"),
      Yes: t("yes"),
      No: t("no"),
    };
    confirmAlert({
      customUI: ({ onClose }) => {
        return getConfirmWarningMessage(
          onClose,
          () => {
            EventService.addEventToCompanyCalendar(props.event.evenT_ID);
          },
          defaultAlertMessages
        );
      },
    });
  }

  return (
    <Card style={{ flex: 1 }}>
      <CardHeader>
        <CardTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <i className="fa fa-info-circle"></i> {t("event_info")}
            </div>
            <Button
              color="primary"
              type="button"
              size="sm"
              onClick={() => {
                addToCalendar();
              }}
            >
              <i className="fa fa-building"></i> {t("add_company_calendar")}
            </Button>
          </div>
        </CardTitle>
      </CardHeader>
      <CardBody>
        <Row>
          <Col lg="6" md="6" xs="12">
            <List type="unstyled">
              {renderListItem(
                "fa-building",
                "event_name",
                props.event.etkinliK_ADI
              )}
              {renderListItem("fa-building", "section", props.event.boluM_ADI)}
              {renderListItem(
                "fa-building",
                "event_type",
                props.event.etkinliK_TIPI_ADI
              )}
              {renderListItem(
                "fa-building",
                "region",
                props.event.yurticI_YURTDISI
              )}
              {renderListItem(
                "fa-building",
                "count_of_guests",
                props.event.misafiR_SAYISI
              )}
              {renderListItem(
                "fa-building",
                "guest_pic",
                props.event.misafiR_SORUMLUSU_AD_SOYAD
              )}
              {renderListItem(
                "fa-building",
                "description",
                props.event.aciklama
              )}
            </List>
          </Col>
          <Col lg="6" md="6" xs="12">
            <List type="unstyled"></List>
          </Col>
        </Row>
        <List type="unstyled">
          {renderListItem(
            "fa-building",
            "requester_affiliate",
            props.event.taleP_EDEN_AFFILIATE_KODU
          )}
          {renderListItem(
            "fa-building",
            "requester_country",
            props.event.taleP_EDEN_ULKE_KODU
          )}
          {renderListItem(
            "fa-building",
            "department_to_be_billed",
            props.event.faturA_EDILECEK_DEPARTMAN_KODU
          )}
          {renderListItem(
            "fa-building",
            "affiliate_to_be_billed",
            props.event.faturA_EDILECEK_AFFILIATE_KODU
          )}
          {renderListItem(
            "fa-building",
            "launch_type",
            props.event.lansmaN_TIPI
          )}
          {renderListItem(
            "fa-building",
            "online_physical",
            props.event.onlinE_FIZIKI
          )}
          {renderListItem("fa-building", "location", props.event.lokasyoN_ADI)}
          {renderListItem(
            "fa-building",
            "location_address",
            props.event.lokasyoN_ADRES
          )}
          {renderListItem(
            "fa-building",
            "meeting_type",
            props.event.toplantI_TIPI
          )}

          {renderListItem(
            "fa-building",
            "internal_external",
            props.event.sirkeT_ICI_SIRKET_DISI
          )}
          {renderListItem(
            "fa-building",
            "internal_communication_type",
            props.event.iC_ILETISIM_TIPI
          )}
          {renderListItem(
            "fa-building",
            "yearend_meeting_type",
            props.event.yilsonU_TOPLANTI_TIPI
          )}
          {renderListItem(
            "fa-building",
            "regional_meeting_type",
            props.event.bolgeseL_TOPLANTI_TIPI
          )}
          {renderListItem(
            "fa-building",
            "regional_meal_type",
            props.event.bolgeseL_YEMEK_TIPI
          )}
          {renderListItem(
            "fa-building",
            "travel_type",
            props.event.seyahaT_TIPI
          )}
          {renderListItem(
            "fa-building",
            "product_control",
            props.event.uruN_KONTROL
          )}
          {renderListItem(
            "fa-building",
            "sponsorship_type",
            props.event.sponsorluK_TIPI
          )}
          {renderListItem(
            "fa-building",
            "sales_responsive",
            props.event.satiS_TEMSILCISI_AD_SOYAD
          )}
          {renderListItem(
            "fa-building",
            "requester_department",
            props.event.taleP_EDEN_DEPARTMAN_ADI
          )}
          {renderListItem("fa-building", "project_name", props.event.projE_ADI)}
          {renderListItem(
            "fa-building",
            "project_cost",
            props.event.projE_BEDELI
          )}
          {renderListItem(
            "fa-building",
            "training_seminar",
            props.event.egitiM_SEMINER
          )}
          {renderListItem("fa-building", "trainer", props.event.egitmen)}

          {Object.entries(additionalInfo).map(([key, value]) =>
            renderListItem("fa-building", key, value)
          )}
        </List>
      </CardBody>
    </Card>
  );
}

export { EventInfoCard };
